import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-identification-help',
    templateUrl: './identification-help.component.html',
    standalone: false
})
export class IdentificationHelpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }

}
